webpackJsonp([27],{

/***/ 100:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_font_color_contrast__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_font_color_contrast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_font_color_contrast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loading_vue__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Loading_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'tud-drawer': function tudDrawer() {
      return {
        component: __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 196)),

        loading: __WEBPACK_IMPORTED_MODULE_1__components_Loading_vue___default.a,

        delay: 200
      };
    },
    'tud-toolbar': function tudToolbar() {
      return {
        component: __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 203)),

        loading: __WEBPACK_IMPORTED_MODULE_1__components_Loading_vue___default.a,

        delay: 200
      };
    },
    'tud-footer': function tudFooter() {
      return {
        component: __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 198)),

        loading: __WEBPACK_IMPORTED_MODULE_1__components_Loading_vue___default.a,

        delay: 200
      };
    },
    'tud-snack': function tudSnack() {
      return {
        component: __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 202)),

        loading: __WEBPACK_IMPORTED_MODULE_1__components_Loading_vue___default.a,

        delay: 200
      };
    }
  },
  computed: {
    client: function client() {
      return this.$store.getters.client;
    },
    primaryStyle: function primaryStyle() {
      if (this.client && this.client.data.colors) {
        return {
          backgroundColor: this.client.data.colors.primary,
          color: __WEBPACK_IMPORTED_MODULE_0_font_color_contrast___default()(this.client.data.colors.primary)
        };
      } else {
        return {};
      }
    },
    loading: function loading() {
      return this.$store.getters.getLoading;
    },
    messages: function messages() {
      return this.$store.getters.snacksMessages;
    },
    visibleMessages: function visibleMessages() {
      return this.$store.getters.snacksVisible;
    }
  },
  methods: {
    translate: function translate(sheet, item) {
      return this.$store.getters.translate(sheet, item);
    }
  }
});

/***/ }),

/***/ 101:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'tud-users': function tudUsers() {
      return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 209));
    },
    'tud-clients': function tudClients() {
      return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 204));
    },
    'tud-settings': function tudSettings() {
      return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 208));
    },
    'tud-flyers': function tudFlyers() {
      return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 207));
    },
    'tud-downloads': function tudDownloads() {
      return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 206));
    },
    'tud-dictionary': function tudDictionary() {
      return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 205));
    }
  },
  data: function data() {
    return {
      tab: 1,
      display: {
        mode: 'list',
        icon: 'list',
        label: 'Display (*lista / tabel)'
      }
    };
  },

  computed: {
    component: function component() {
      switch (this.tab) {
        case 1:
          return 'tud-users';
        case 2:
          return 'tud-clients';
        case 3:
          return 'tud-settings';
        case 4:
          return 'tud-flyers';
        case 5:
          return 'tud-downloads';
        case 6:
          return 'tud-dictionary';
      }
    },
    type: function type() {
      switch (this.tab) {
        case 1:
          return 'User';
        case 2:
          return 'Client';
        case 3:
          return 'Setting';
        case 4:
          return 'Flyer';
        case 5:
          return 'Download';
        case 6:
          return 'Dictionary';
      }
    },
    title: function title() {
      switch (this.tab) {
        case 1:
          return 'Utilizatori';
        case 2:
          return 'Clienti';
        case 3:
          return 'Setari';
        case 4:
          return 'Flyere';
        case 5:
          return 'Pagina download flyere';
        case 6:
          return 'Dictionary';
      }
    }
  },
  methods: {
    toggleDisplay: function toggleDisplay() {
      this.display.mode = this.display.mode === 'list' ? 'table' : 'list';
      this.display.icon = this.display.icon === 'list' ? 'grid_on' : 'list';
      this.display.label = 'Layout (' + (this.display.mode === 'list' ? '*lista / tabel' : 'lista / *tabel') + ')';
    }
  }
});

/***/ }),

/***/ 129:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 130:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 173:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(100),
  /* template */
  __webpack_require__(178),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 174:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(130)

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(101),
  /* template */
  __webpack_require__(177),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 175:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "flex",
      "height": "200px",
      "width": "100%",
      "align-items": "center",
      "justify-content": "center",
      "transform": "scale(0.25)"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/gears_loading_1.svg",
      "alt": "incarcare..."
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "margin-top": "100px"
    },
    attrs: {
      "src": "/static/gears_loading_3.svg",
      "alt": "loading..."
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "margin-top": "-50px",
      "margin-left": "-50px"
    },
    attrs: {
      "src": "/static/gears_loading_2.svg",
      "alt": "incarcare..."
    }
  })])
}]}

/***/ }),

/***/ 176:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "dark": !_vm.light,
      "light": _vm.light
    }
  }, [_c('tud-layout')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 177:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "align-self-stretch pb-5",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Dashboard")]), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: _vm.display.label
      }),
      expression: "{ html: display.label }",
      arg: "left"
    }],
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggleDisplay($event)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "primary": _vm.display.icon === 'list'
    }
  }, [_vm._v("list")]), _vm._v(" "), _c('v-icon', [_vm._v("swap_horiz")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "primary": _vm.display.icon === 'grid_on'
    }
  }, [_vm._v("grid_on")])], 1), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-2 wrap"
  }, [_c(_vm.component, {
    tag: "component",
    attrs: {
      "display": _vm.display,
      "type": _vm.type,
      "title": _vm.title
    }
  })], 1), _vm._v(" "), _c('v-bottom-nav', {
    staticClass: "primary",
    attrs: {
      "shift": "",
      "value": "true"
    }
  }, [_c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "value": _vm.tab === 1
    },
    nativeOn: {
      "click": function($event) {
        _vm.tab = 1
      }
    }
  }, [_c('span', [_vm._v("Utilizatori")]), _vm._v(" "), _c('v-icon', [_vm._v("person")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "value": _vm.tab === 2
    },
    nativeOn: {
      "click": function($event) {
        _vm.tab = 2
      }
    }
  }, [_c('span', [_vm._v("Clienti")]), _vm._v(" "), _c('v-icon', [_vm._v("business")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "value": _vm.tab === 3
    },
    nativeOn: {
      "click": function($event) {
        _vm.tab = 3
      }
    }
  }, [_c('span', [_vm._v("Setari")]), _vm._v(" "), _c('v-icon', [_vm._v("settings")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "value": _vm.tab === 4
    },
    nativeOn: {
      "click": function($event) {
        _vm.tab = 4
      }
    }
  }, [_c('span', [_vm._v("Flyers")]), _vm._v(" "), _c('v-icon', [_vm._v("insert_drive_file")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "value": _vm.tab === 5
    },
    nativeOn: {
      "click": function($event) {
        _vm.tab = 5
      }
    }
  }, [_c('span', [_vm._v("Download")]), _vm._v(" "), _c('v-icon', [_vm._v("cloud_download")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "value": _vm.tab === 6
    },
    nativeOn: {
      "click": function($event) {
        _vm.tab = 6
      }
    }
  }, [_c('span', [_vm._v("Dictionar")]), _vm._v(" "), _c('v-icon', [_vm._v("library_books")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 178:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('tud-drawer'), _vm._v(" "), _c('tud-toolbar'), _vm._v(" "), _c('main', {
    staticStyle: {
      "min-height": "90vh"
    }
  }, [_c('v-progress-linear', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "indeterminate": true,
      "height": "2",
      "color-front": "blue-grey",
      "color-back": "blue-grey lighten-2"
    }
  }), _vm._v(" "), _c('v-container', {
    staticClass: "pa-1",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": "",
      "child-flex": ""
    }
  }, [_c('router-view', {
    key: _vm.$route.params.id,
    attrs: {
      "keep-alive": ""
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('footer', {
    staticStyle: {
      "padding-bottom": "68px"
    }
  }, [_c('div', {
    staticClass: "elevation-0 pl-2 pr-2",
    staticStyle: {
      "background-color": "transparent",
      "font-size": "0.8em",
      "color": "#aaa",
      "text-shadow": "1px 1px 3px #bbb",
      "text-align": "center"
    }
  }, [_vm._v("\n      Developed by "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://tudconsult.ro/"
    }
  }, [_vm._v("TUD")]), _vm._v(" "), _c('br'), _vm._v("\n      © Verde Smart Data. " + _vm._s(_vm.translate('interfata', 'app-copyright')) + "\n      "), _c('br'), _vm._v("\n      " + _vm._s(_vm.translate('interfata', 'app-icon-surse')) + "\n    ")])]), _vm._v(" "), _c('tud-snack', {
    staticStyle: {
      "z-index": "12000"
    },
    attrs: {
      "messages": _vm.messages,
      "visible": _vm.visibleMessages
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 30:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__feathers___ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n___ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_users__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_clients__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_settings__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_datasets__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_flyers__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_downloads__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store_dictionary__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_cookies_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_cookies_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_cookies_js__);

















__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
  modules: {
    users: __WEBPACK_IMPORTED_MODULE_5__store_users__["a" /* default */], clients: __WEBPACK_IMPORTED_MODULE_6__store_clients__["a" /* default */], settings: __WEBPACK_IMPORTED_MODULE_7__store_settings__["a" /* default */], datasets: __WEBPACK_IMPORTED_MODULE_8__store_datasets__["a" /* default */], flyers: __WEBPACK_IMPORTED_MODULE_9__store_flyers__["a" /* default */], downloads: __WEBPACK_IMPORTED_MODULE_10__store_downloads__["a" /* default */], dictionary: __WEBPACK_IMPORTED_MODULE_11__store_dictionary__["a" /* default */]
  },
  state: {
    feathers: __WEBPACK_IMPORTED_MODULE_3__feathers___["a" /* default */],
    loading: false,
    fetching: false,
    auth: {
      user: null,
      token: null
    },
    snacks: {
      messages: [],
      visible: false
    },
    app: {
      light: true,
      clipped: true,
      fixed: true,
      drawer: false,
      mini: false,
      menuItems: [{ icon: 'home', title: 'Index', link: '/' }, { icon: 'library_books', title: 'Flyere', link: '/flyere/' }, { icon: 'dashboard', title: 'Dashboard', link: '/dashboard/', auth: true }],
      routes: [{ path: '/comunitatea-locala', meta: { index: 0, trans: 'ov-tab-titlu', page: 'overview', subtrans: null } }, { path: '/buget-general-centralizat/bgc-rezumat', meta: { index: 1, trans: 'bgc-tab-titlu', page: 'bgc', subtrans: 'bgc-tab-general' } }, { path: '/buget-general-centralizat/bgc-structura', meta: { index: 2, trans: 'bgc-tab-titlu', page: 'bgc', subtrans: 'bgc-tab-defalcat' } }, { path: '/buget-general-centralizat/bgc-nivel-realizat', meta: { index: 3, trans: 'bgc-tab-titlu', page: 'bgc', subtrans: 'bgc-tab-tabel' } }, { path: '/buget-local/bl-rezumat', meta: { index: 4, trans: 'bl-tab-titlu', page: 'bl', subtrans: 'bl-tab-general' } }, { path: '/buget-local/bl-venituri', meta: { index: 5, trans: 'bl-tab-titlu', page: 'bl', subtrans: 'bl-tab-venituri' } }, { path: '/buget-local/bl-cheltuieli-functionale', meta: { index: 6, trans: 'bl-tab-titlu', page: 'bl', subtrans: 'bl-tab-ch-fct' } }, { path: '/buget-local/bl-cheltuieli-economice', meta: { index: 7, trans: 'bl-tab-titlu', page: 'bl', subtrans: 'bl-tab-ch-ec' } }, { path: '/buget-local/bl-tabel-cheltuieli', meta: { index: 8, trans: 'bl-tab-titlu', page: 'bl', subtrans: 'bl-tab-matrice' } }, { path: '/contributia-cetateanului', meta: { index: 9, trans: 'cc-tab-titlu', page: 'cc', subtrans: null } }]
    },
    client: {
      data: null,
      timespans: [],
      dataset: null
    },
    excel: null,
    services: {
      users: __WEBPACK_IMPORTED_MODULE_3__feathers___["a" /* default */].service('users'),
      clients: __WEBPACK_IMPORTED_MODULE_3__feathers___["a" /* default */].service('clients'),
      datasets: __WEBPACK_IMPORTED_MODULE_3__feathers___["a" /* default */].service('datasets'),
      settings: __WEBPACK_IMPORTED_MODULE_3__feathers___["a" /* default */].service('settings'),
      xlsx: __WEBPACK_IMPORTED_MODULE_3__feathers___["a" /* default */].service('xlsx'),
      excel: __WEBPACK_IMPORTED_MODULE_3__feathers___["a" /* default */].service('excel'),
      flyers: __WEBPACK_IMPORTED_MODULE_3__feathers___["a" /* default */].service('flyers'),
      downloads: __WEBPACK_IMPORTED_MODULE_3__feathers___["a" /* default */].service('downloads'),
      dictionar: __WEBPACK_IMPORTED_MODULE_3__feathers___["a" /* default */].service('dictionar'),
      dictionary: __WEBPACK_IMPORTED_MODULE_3__feathers___["a" /* default */].service('dictionary')
    },
    settingsObject: null,
    year: null,
    quarter: null,
    setBLTabArcId: null
  },
  getters: {
    snacksVisible: function snacksVisible(state) {
      return state.snacks.visible;
    },
    snacksMessages: function snacksMessages(state) {
      return state.snacks.messages;
    },
    appLight: function appLight(state) {
      return state.app.light;
    },
    appFixed: function appFixed(state) {
      return state.app.fixed;
    },
    appDrawer: function appDrawer(state) {
      return state.app.drawer;
    },
    appMini: function appMini(state) {
      return state.app.mini;
    },
    appClipped: function appClipped(state) {
      return state.app.clipped;
    },
    appMenuItems: function appMenuItems(state) {
      return state.app.menuItems;
    },
    getUser: function getUser(state) {
      return state.auth.user;
    },
    getLoading: function getLoading(state) {
      return state.loading;
    },
    getFetching: function getFetching(state) {
      return state.fetching;
    },
    client: function client(state) {
      return state.client;
    },
    getIndexDataset: function getIndexDataset(state) {
      return state.client.dataset;
    },
    getExcelExists: function getExcelExists(state) {
      return !!state.excel;
    },
    getExcelBGC: function getExcelBGC(state) {
      return state.excel ? state.excel.BGC : null;
    },
    getExcelBGCBugete: function getExcelBGCBugete(state) {
      return state.excel ? state.excel.BGC.bugete : null;
    },
    getExcelBGCGeneral: function getExcelBGCGeneral(state) {
      return state.excel ? state.excel.BGC.general : null;
    },
    getExcelBGCVenCh: function getExcelBGCVenCh(state) {
      return state.excel ? state.excel.BGC.vench : null;
    },
    getExcelBGCDefalcat: function getExcelBGCDefalcat(state) {
      return state.excel ? state.excel.BGC.defalcat : null;
    },
    getExcelBGCTable: function getExcelBGCTable(state) {
      return state.excel ? state.excel.BGC.table : null;
    },
    getExcelBL: function getExcelBL(state) {
      return state.excel ? state.excel.BL : null;
    },
    getExcelBLGeneral: function getExcelBLGeneral(state) {
      return state.excel ? state.excel.BL.general : null;
    },
    getExcelBLVenituri: function getExcelBLVenituri(state) {
      return state.excel ? state.excel.BL.venituri : null;
    },
    getExcelBLChFct: function getExcelBLChFct(state) {
      return state.excel ? state.excel.BL.chfct : null;
    },
    getExcelBLChEc: function getExcelBLChEc(state) {
      return state.excel ? state.excel.BL.chec : null;
    },
    getExcelBLMatrice: function getExcelBLMatrice(state) {
      return state.excel ? state.excel.BL.matrice : null;
    },
    getExcelCC: function getExcelCC(state) {
      return state.excel ? state.excel.CC : null;
    },
    getExcelRezumat: function getExcelRezumat(state) {
      return state.excel ? state.excel.rezumat : null;
    },
    getExcelTextOverview: function getExcelTextOverview(state) {
      return state.excel ? state.excel.text['OVERVIEW'] : null;
    },
    getExcelTextCC: function getExcelTextCC(state) {
      return state.excel ? state.excel.text['Contributia Cetateanului'] : null;
    },
    getExcelTextBLMatrice: function getExcelTextBLMatrice(state) {
      return state.excel ? state.excel.text['BL Matrice'] : null;
    },
    getExcelTextBLChEc: function getExcelTextBLChEc(state) {
      return state.excel ? state.excel.text['BL Cheltuieli EC'] : null;
    },
    getExcelTextBLChFct: function getExcelTextBLChFct(state) {
      return state.excel ? state.excel.text['BL Cheltuieli FCT'] : null;
    },
    getExcelTextBLVenituri: function getExcelTextBLVenituri(state) {
      return state.excel ? state.excel.text['BL Venituri'] : null;
    },
    getExcelTextBLGeneral: function getExcelTextBLGeneral(state) {
      return state.excel ? state.excel.text['BL General'] : null;
    },
    getExcelTextBGCStructura: function getExcelTextBGCStructura(state) {
      return state.excel ? state.excel.text['BGC Structura si Nivel Realizat'] : null;
    },
    getExcelTextBGCBugete: function getExcelTextBGCBugete(state) {
      return state.excel ? state.excel.text['BGC Bugete si Institutii'] : null;
    },
    getExcelTextBGCVenCh: function getExcelTextBGCVenCh(state) {
      return state.excel ? state.excel.text['BGC Venituri si Cheltuieli'] : null;
    },
    getExcelTextBGCGeneral: function getExcelTextBGCGeneral(state) {
      return state.excel ? state.excel.text['BGC General'] : null;
    },
    getExcelPopups: function getExcelPopups(state) {
      return state.excel ? state.excel.popups : null;
    },
    getInstitutions: function getInstitutions(state) {
      return state.client.dataset ? state.client.dataset.institutions : null;
    },
    getFunctional: function getFunctional(state) {
      return state.client.dataset ? state.client.dataset.functional : null;
    },
    getColors: function getColors(state) {
      return state.client.data ? state.client.data.colors : null;
    },
    getSettingsObject: function getSettingsObject(state) {
      return state.settingsObject;
    },
    getBLTabArcId: function getBLTabArcId(state) {
      return state.setBLTabArcId;
    },
    getRoutes: function getRoutes(state) {
      return state.app.routes;
    },
    getExcelLegendPopupsvenituri: function getExcelLegendPopupsvenituri(state) {
      return state.excel ? state.excel.popups['Donut Venituri'] || [] : null;
    },
    'getExcelLegendPopupscheltuieli-fct': function getExcelLegendPopupscheltuieliFct(state) {
      return state.excel ? state.excel.popups['Donut ChFct'] || [] : null;
    },
    'getExcelLegendPopupscheltuieli-ec': function getExcelLegendPopupscheltuieliEc(state) {
      return state.excel ? state.excel.popups['Donut ChEc'] || [] : null;
    },
    'getExcelLegendPopupscc': function getExcelLegendPopupscc(state) {
      return [];
    }
  },
  mutations: {
    setLoading: function setLoading(state, data) {
      state.loading = data;
    },
    setFetching: function setFetching(state, data) {
      state.fetching = data;
    },
    setAuth: function setAuth(state, data) {
      state.auth.token = data.token;
      state.auth.user = data.user;
      state.auth.error = null;
      state.loading = false;
    },
    setSnack: function setSnack(state, data) {
      data.message = data.meta.error ? data.code ? __WEBPACK_IMPORTED_MODULE_4__i18n___["a" /* errorMessages */][data.code] : data.message : data.message;
      state.snacks.messages.push(data);
      state.snacks.visible = true;
    },
    toggleSnacks: function toggleSnacks(state, value) {
      state.snacks.visible = value;
    },
    removeSnack: function removeSnack(state) {
      state.snacks.messages.splice(0, 1);
    },
    toggleLight: function toggleLight(state) {
      state.app.light = !state.app.light;
    },
    setLight: function setLight(state, payload) {
      state.app.light = !!payload;
    },
    closeDrawer: function closeDrawer(state) {
      state.app.drawer = false;
    },
    openDrawer: function openDrawer(state) {
      state.app.drawer = true;
    },
    toggleMini: function toggleMini(state) {
      state.app.mini = !state.app.mini;
    },
    clearMessages: function clearMessages(state) {
      state.snacks.messages = [];
      state.snacks.visible = false;
    },
    setClient: function setClient(state, client) {
      __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].set(state.client, 'data', client);
    },
    setTimespans: function setTimespans(state, timespans) {
      __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].set(state.client, 'timespans', timespans);
    },
    setIndexDataset: function setIndexDataset(state, dataset) {
      __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].set(state.client, 'dataset', dataset);
    },
    setExcel: function setExcel(state, data) {
      __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].set(state, 'excel', data);
    },
    setSettingsObject: function setSettingsObject(state, payload) {
      state.settingsObject = payload;
    },
    setYearQuarter: function setYearQuarter(state, payload) {
      state.year = payload.year;
      state.quarter = payload.quarter;
    },
    setBLTab: function setBLTab(state, payload) {
      state.BLTab = payload;
    },
    setBLTabArcId: function setBLTabArcId(state, payload) {
      state.setBLTabArcId = payload;
    }
  },
  actions: {
    login: function login(_ref, data) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch;

      commit('setLoading', true);
      return __WEBPACK_IMPORTED_MODULE_3__feathers___["a" /* default */].authenticate({
        strategy: 'local',
        email: data.email,
        password: data.password
      }).then(function (response) {
        return grabAuthData(response, commit, dispatch);
      }).catch(function (error) {
        error.meta = { error: true, success: false, info: false, warning: false };
        commit('setSnack', error);
        commit('setLoading', false);
      });
    },
    logout: function logout(_ref2) {
      var commit = _ref2.commit;

      commit('setLoading', true);
      __WEBPACK_IMPORTED_MODULE_3__feathers___["a" /* default */].logout().then(function (response) {
        commit('setAuth', { token: null, user: null });
        commit('clearUsers');
        commit('setLoading', false);
        commit('setSnack', {
          message: 'Sesiunea de lucru a fost inchisa. Sunteti in modul anonim.',
          meta: {
            error: false,
            success: true,
            info: false,
            warning: false
          }
        });
      }).catch(function (error) {
        error.meta = { error: true, success: false, info: false, warning: false };
        commit('setSnack', error);
        commit('setLoading', false);
      });
    },
    attemptAuth: function attemptAuth(_ref3) {
      var commit = _ref3.commit,
          dispatch = _ref3.dispatch,
          state = _ref3.state;

      __WEBPACK_IMPORTED_MODULE_3__feathers___["a" /* default */].passport.getJWT().then(function (jwt) {
        if (jwt) {
          return state.feathers.authenticate({ strategy: 'jwt', accessToken: jwt });
        }
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(null);
      }).then(function (response) {
        if (response) {
          return grabAuthData(response, commit, dispatch);
        } else {
          commit('setLoading', false);
        }
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(null);
      }).catch(function (error) {
        error.meta = { error: true, success: false, info: false, warning: false };
        commit('setSnack', error);
        commit('setLoading', false);
      });
    },
    getClientData: function getClientData(_ref4, id) {
      var commit = _ref4.commit,
          state = _ref4.state;

      if (state.client.data && id === state.client.data._id) return;

      var lang = __WEBPACK_IMPORTED_MODULE_12_cookies_js___default.a.get('bgt-lang');
      var languageSet = false;

      if (lang) {
        languageSet = true;
      } else if (!lang && navigator.language) {
        languageSet = false;
        lang = 'RO';
      }
      commit('setLanguage', { lang: lang, languageSet: languageSet });
      commit('setLoading', true);

      state.services.clients.get(id).then(function (result) {
        commit('setClient', result);
        return state.services.datasets.find({
          query: {
            clientID: result._id,
            $select: ['year', 'quarter', 'approved', 'draft', 'clientID'],
            $sort: {
              year: -1,
              quarter: -1
            },
            paginate: false
          }
        });
      }).then(function (result) {
        commit('setTimespans', result);

        commit('setLoading', false);
      }).catch(function (error) {
        error.meta = { error: true, success: false, info: false, warning: false };
        commit('setSnack', error);
        commit('setLoading', false);
      });
    },
    fetchIndexDataset: function fetchIndexDataset(_ref5, id) {
      var commit = _ref5.commit,
          state = _ref5.state;

      commit('setLoading', true);
      state.services.datasets.get(id).then(function (result) {
        commit('setIndexDataset', result);
        return state.services.excel.find({
          query: {
            datasetId: id
          }
        });
      }).then(function (result) {
        commit('setExcel', result.data.length ? result.data[0] : null);
        return state.services.settings.find({
          query: {
            year: state.year,
            quarter: state.quarter
          }
        });
      }).then(function (result) {
        commit('setSettingsObject', result.data.length ? result.data[0] : null);
        commit('setLoading', false);
      }).catch(function (error) {
        commit('setLoading', false);
        error.meta = { error: true, success: false, info: false, warning: false };
        commit('setSnack', error);
        commit('setLoading', false);
      });
    },
    uploadFile: function uploadFile(_ref6, data) {
      var commit = _ref6.commit,
          state = _ref6.state;

      commit('setLoading', true);
      state.services.xlsx.create(data).then(function (result) {
        commit('setLoading', false);
      }).catch(function (error) {
        commit('setLoading', false);
        error.meta = { error: true, success: false, info: false, warning: false };
        commit('setSnack', error);
        commit('setLoading', false);
      });
    }
  }
}));

function grabAuthData(response, commit, dispatch) {
  return __WEBPACK_IMPORTED_MODULE_3__feathers___["a" /* default */].passport.verifyJWT(response.accessToken).then(function (result) {
    return __WEBPACK_IMPORTED_MODULE_3__feathers___["a" /* default */].service('users').get(result.userId);
  }).then(function (data) {
    commit('setAuth', { token: response.accessToken, user: data });
    commit('setSnack', {
      message: 'Autentificare reusita. Sesiune de lucru pornita.',
      meta: {
        error: false,
        success: true,
        info: false,
        warning: false
      }
    });
    dispatch('setEventWatchers');
  }).catch(function (error) {
    console.log(error);
    error.meta = { error: true, success: false, info: false, warning: false };
    commit('setSnack', error);
    commit('setLoading', false);
  });
}

/***/ }),

/***/ 55:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_Dashboard__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_Dashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_admin_Dashboard__);




var Index = function Index() {
  return {
    component: __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 199)),
    delay: 200,
    timeout: Infinity
  };
};
var Login = function Login() {
  return {
    component: __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 200)),
    delay: 200,
    timeout: Infinity
  };
};
var Flyers = function Flyers() {
  return {
    component: __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 197)),
    delay: 200,
    timeout: Infinity
  };
};

var Overview = function Overview() {
  return {
    component: __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 201)),
    delay: 200,
    timeout: Infinity
  };
};

var BGC = function BGC() {
  return {
    component: __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 184)),
    delay: 200,
    timeout: Infinity
  };
};
var BGCRezumat = function BGCRezumat() {
  return {
    component: __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 186)),
    delay: 200,
    timeout: Infinity
  };
};
var BGCVenCh = function BGCVenCh() {
  return {
    component: __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 188)),
    delay: 200,
    timeout: Infinity
  };
};
var BGCStructura = function BGCStructura() {
  return {
    component: __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 185)),
    delay: 200,
    timeout: Infinity
  };
};
var BGCTabel = function BGCTabel() {
  return {
    component: __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 187)),
    delay: 200,
    timeout: Infinity
  };
};

var BL = function BL() {
  return {
    component: __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 189)),
    delay: 200,
    timeout: Infinity
  };
};
var BLRezumat = function BLRezumat() {
  return {
    component: __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 192)),
    delay: 200,
    timeout: Infinity
  };
};
var BLVenituri = function BLVenituri() {
  return {
    component: __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 194)),
    delay: 200,
    timeout: Infinity
  };
};
var BLChFct = function BLChFct() {
  return {
    component: __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 191)),
    delay: 200,
    timeout: Infinity
  };
};
var BLChEc = function BLChEc() {
  return {
    component: __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 190)),
    delay: 200,
    timeout: Infinity
  };
};
var BLMatrice = function BLMatrice() {
  return {
    component: __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 193)),
    delay: 200,
    timeout: Infinity
  };
};

var CC = function CC() {
  return {
    component: __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 195)),
    delay: 200,
    timeout: Infinity
  };
};



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Index',
    component: Login
  }, {
    path: '/login/:id?',
    name: 'Login',
    component: Login
  }, {
    path: '/dashboard/:id?',
    name: 'Dashboard',
    component: __WEBPACK_IMPORTED_MODULE_3__components_admin_Dashboard___default.a,
    meta: { requiresAuth: true }
  }, {
    path: '/flyere/:id?',
    name: 'Flyere',
    component: Flyers
  }, {
    path: '/:id',
    component: Index,
    beforeEnter: function beforeEnter(to, from, next) {
      if (to.params.id) {
        next();
      }
    },
    children: [{ path: '', redirect: 'comunitatea-locala' }, { path: 'comunitatea-locala', component: Overview, name: 'overview', meta: { dict: 'overview' } }, {
      path: 'buget-general-centralizat',
      component: BGC,
      children: [{ path: '', redirect: 'bgc-rezumat' }, { path: 'bgc-rezumat', components: { rezumat: BGCRezumat, vench: BGCVenCh }, name: 'bgc-rezumat', meta: { dict: 'bgc' } }, { path: 'bgc-structura', components: { rezumat: BGCStructura, vench: null }, name: 'bgc-structura', meta: { dict: 'bgc' } }, { path: 'bgc-nivel-realizat', components: { rezumat: BGCTabel, vench: null }, name: 'bgc-nivel-realizat', meta: { dict: 'bgc' } }]
    }, {
      path: 'buget-local',
      component: BL,
      children: [{ path: '', redirect: 'bl-rezumat' }, { path: 'bl-rezumat', components: { content: BLRezumat }, name: 'bl-rezumat', meta: { dict: 'bl' } }, { path: 'bl-venituri', components: { content: BLVenituri }, name: 'bl-venituri', meta: { dict: 'bl' } }, { path: 'bl-cheltuieli-functionale', components: { content: BLChFct }, name: 'bl-ch-fct', meta: { dict: 'bl' } }, { path: 'bl-cheltuieli-economice', components: { content: BLChEc }, name: 'bl-ch-ec', meta: { dict: 'bl' } }, { path: 'bl-tabel-cheltuieli', components: { content: BLMatrice }, name: 'bl-matrice', meta: { dict: 'bl' } }]
    }, { path: 'contributia-cetateanului', component: CC, name: 'cc', meta: { dict: 'cc' } }]
  }]
});

router.beforeEach(function (to, from, next) {
  var watcher = void 0;
  if (__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getLoading) {
    watcher = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].watch(function (state) {
      return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getLoading;
    }, function (loading) {
      proceed();
    });
  } else {
    proceed();
  }

  function proceed() {
    if (watcher) {
      watcher();
    }
    if (to.matched.some(function (record) {
      return record.meta.requiresAuth;
    })) {
      if (__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getUser) {
        next();
      } else {
        next({ name: 'Index' });
      }
    } else {
      next();
    }
  }
});

router.afterEach(function (to, from) {
  var cs = document.documentElement.scrollTop || document.body.scrollTop;

  function smoothscroll() {
    var currentScroll = document.documentElement.scrollTop || document.body.scrollTop;

    if (currentScroll > 0 && currentScroll <= cs) {
      cs = currentScroll;
      window.requestAnimationFrame(smoothscroll);
      window.scrollTo(0, currentScroll - currentScroll / 5);
    }
  }

  smoothscroll();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 56:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(129)

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(99),
  /* template */
  __webpack_require__(176),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 64:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(9)(
  /* script */
  null,
  /* template */
  __webpack_require__(175),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 89:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var feathers = __webpack_require__(147);
var socketio = __webpack_require__(145);
var hooks = __webpack_require__(141);

var auth = __webpack_require__(135);
var io = __webpack_require__(171);

var socket = io('https://buget.verdedata.ro', {
  transports: ['websocket']
});

var feathersClient = feathers().configure(socketio(socket, {
  timeout: 60000
})).configure(hooks()).configure(auth({ storage: localStorage }));

/* harmony default export */ __webpack_exports__["a"] = (feathersClient);

/***/ }),

/***/ 90:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return errorMessages; });
var errorMessages = {
  400: '(400) Eroare la procesarea cererii.',
  401: '(401) Autentificare esuata.',
  402: '(402) Eroare la procesrea platii.',
  403: '(403) Acces restrictionat.',
  404: '(404) Resursa negasita.',
  405: '(405) Apel nepermis.',
  406: '(406) Raspuns formatat gresit.',
  408: '(408) Timpul alocat operatiunii a fost depasit.',
  409: '(409) Conflict in procesarea cererii.',
  411: '(411) Cererea nu are o lungime definita.',
  422: '(422) Cerere ce nu poate fi procesata.',
  429: '(429) Prea multe cereri.',
  500: '(500) Eroare generala',
  501: '(501) Metoda de procesare neimplementata.',
  502: '(502) Eroare de server.',
  503: '(503) Server indisponibil.'
};

/***/ }),

/***/ 91:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store___ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_throttle__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_throttle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_debounce__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_v_tooltip__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vueg_css_transition_min_css__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vueg_css_transition_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vueg_css_transition_min_css__);














__WEBPACK_IMPORTED_MODULE_8_v_tooltip__["a" /* VTooltip */].options.defaultTrigger = 'click hover';
__WEBPACK_IMPORTED_MODULE_8_v_tooltip__["a" /* VTooltip */].options.disposeTimeout = 5000;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('tud-tooltip', __WEBPACK_IMPORTED_MODULE_8_v_tooltip__["a" /* VTooltip */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$axios = __WEBPACK_IMPORTED_MODULE_4_axios___default.a;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$throttle = __WEBPACK_IMPORTED_MODULE_6_lodash_throttle___default.a;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$debounce = __WEBPACK_IMPORTED_MODULE_7_lodash_debounce___default.a;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_5__store___["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a }
});

/***/ }),

/***/ 92:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    clients: {
      data: [],
      search: '',
      page: 1,
      totalPages: 1,
      sort: {
        name: 1
      }
    }
  },
  getters: {
    getAllClients: function getAllClients(state) {
      return state.clients;
    },
    getClientsPage: function getClientsPage(state) {
      return state.clients.page;
    },
    getClientSearch: function getClientSearch(state) {
      return state.clients.search;
    }
  },
  mutations: {
    fillClients: function fillClients(state, data) {
      state.clients.data = data;
    },
    clearClients: function clearClients(state) {
      state.clients.data = [];
    },
    setClientsPage: function setClientsPage(state, page) {
      state.clients.page = page;
    },
    setClientsSort: function setClientsSort(state, sort) {
      state.clients.sort = sort;
    },
    setClientSearch: function setClientSearch(state, search) {
      state.clients.search = search;
    }
  },
  actions: {
    fetchClients: function fetchClients(_ref) {
      var commit = _ref.commit,
          state = _ref.state,
          rootState = _ref.rootState;

      commit('setFetching', true);
      var query = {
        $skip: (state.clients.page - 1) * 10,
        $sort: state.clients.sort
      };
      if (state.clients.search.length) {
        query['orRegex'] = [{
          name: {
            $search: state.clients.search
          }
        }];
      }
      rootState.services.clients.find({ query: query }).then(function (result) {
        commit('fillClients', result);
        commit('setFetching', false);
      });
    },
    saveClient: function saveClient(_ref2, data) {
      var dispatch = _ref2.dispatch,
          commit = _ref2.commit,
          state = _ref2.state,
          rootState = _ref2.rootState;

      rootState.services.clients.create(data).then(function (res) {
        dispatch('fetchClients');
        commit('setSnack', {
          message: 'Operatiune reusita. Client adaugat.',
          meta: {
            error: false,
            success: true,
            info: false,
            warning: false
          }
        });
      }).catch(function (error) {
        console.log(error);
        error.meta = { error: true, success: false, info: false, warning: false };
        commit('setSnack', error);
      });
    },
    updateClient: function updateClient(_ref3, data) {
      var dispatch = _ref3.dispatch,
          commit = _ref3.commit,
          state = _ref3.state,
          rootState = _ref3.rootState;

      rootState.services.clients.update(data._id, data).then(function (res) {
        dispatch('fetchClients');
        commit('setSnack', {
          message: 'Operatiune reusita. Client modificat.',
          meta: {
            error: false,
            success: true,
            info: false,
            warning: false
          }
        });
      }).catch(function (error) {
        error.meta = { error: true, success: false, info: false, warning: false };
        commit('setSnack', error);
      });
    },
    deleteClient: function deleteClient(_ref4, _ids) {
      var dispatch = _ref4.dispatch,
          commit = _ref4.commit,
          state = _ref4.state,
          rootState = _ref4.rootState;

      rootState.services.clients.remove(null, { query: { _id: { $in: _ids } } }).then(function (res) {
        dispatch('fetchClients');
        commit('setSnack', {
          message: 'Operatiune reusita. ' + res.length + ' client(i) eliminat(i).',
          meta: {
            error: false,
            success: true,
            info: false,
            warning: false
          }
        });
      }).catch(function (error) {
        error.meta = { error: true, success: false, info: false, warning: false };
        commit('setSnack', error);
      });
    },
    setClientsPage: function setClientsPage(_ref5, page) {
      var commit = _ref5.commit,
          dispatch = _ref5.dispatch;

      commit('setClientsPage', page);
      dispatch('fetchClients');
    },
    setClientsSort: function setClientsSort(_ref6, sort) {
      var commit = _ref6.commit,
          dispatch = _ref6.dispatch;

      commit('setClientsSort', sort);
      dispatch('fetchClients');
    },
    setClientSearch: function setClientSearch(_ref7, search) {
      var commit = _ref7.commit,
          dispatch = _ref7.dispatch;

      commit('setClientSearch', search);
      dispatch('fetchClients');
    }
  }
});

/***/ }),

/***/ 93:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    datasets: {
      data: [],
      search: '',
      page: 1,
      totalPages: 1,
      sort: {
        name: 1
      }
    }
  },
  getters: {},
  mutations: {},
  actions: {
    fetchClientDataset: function fetchClientDataset(_ref, payload) {
      var commit = _ref.commit,
          rootState = _ref.rootState;

      return rootState.services.datasets.get(payload.id);
    },
    fetchClientTimespans: function fetchClientTimespans(_ref2, payload) {
      var commit = _ref2.commit,
          rootState = _ref2.rootState;

      return rootState.services.datasets.find({
        query: {
          clientID: payload.id,
          $select: ['year', 'quarter', 'approved', 'minimal', 'minimalLite'],
          $sort: {
            year: -1,
            quarter: -1
          },
          paginate: false
        }
      });
    },
    updateDataset: function updateDataset(_ref3, payload) {
      var commit = _ref3.commit,
          rootState = _ref3.rootState;

      commit('setLoading', true);

      rootState.services.datasets.patch(payload._id, payload).then(function (res) {
        commit('setLoading', false);
      }).catch(function (err) {
        console.log(err);
      });
    },
    saveDataset: function saveDataset(_ref4, payload) {
      var commit = _ref4.commit,
          rootState = _ref4.rootState;

      commit('setLoading', true);
      rootState.services.datasets.create(payload).then(function (res) {
        commit('setLoading', false);
      }).catch(function (err) {
        console.log(err);
      });
    },
    deleteDataset: function deleteDataset(_ref5, payload) {
      var commit = _ref5.commit,
          rootState = _ref5.rootState;

      commit('setLoading', true);
      rootState.services.datasets.remove(payload).then(function (res) {
        commit('setLoading', false);
      }).catch(function (err) {
        console.log(err);
      });
    },
    approveDataset: function approveDataset(_ref6, payload) {
      var commit = _ref6.commit,
          rootState = _ref6.rootState;

      commit('setLoading', true);
      rootState.services.datasets.patch(payload, { approved: true }).then(function (res) {
        commit('setLoading', false);
      }).catch(function (err) {
        console.log(err);
      });
    },
    disapproveDataset: function disapproveDataset(_ref7, payload) {
      var commit = _ref7.commit,
          rootState = _ref7.rootState;

      commit('setLoading', true);
      rootState.services.datasets.patch(payload, { approved: false }).then(function (res) {
        commit('setLoading', false);
      }).catch(function (err) {
        console.log(err);
      });
    }
  }
});

/***/ }),

/***/ 94:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_slug__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_slug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_slug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_cookies_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_cookies_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_cookies_js__);



/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    dictionary: {
      data: [],
      search: '',
      page: 1,
      totalPages: 1,
      sort: {
        name: 1
      }
    },
    selectedLanguage: 'RO',
    languageSet: false
  },
  getters: {
    getAllDictionarys: function getAllDictionarys(state) {
      return state.dictionary;
    },
    getDictionarysPage: function getDictionarysPage(state) {
      return state.dictionary.page;
    },
    getDictionarySearch: function getDictionarySearch(state) {
      return state.dictionary.search;
    },
    getDictionarysData: function getDictionarysData(state) {
      if (state.dictionary.data && state.dictionary.data.data && state.dictionary.data.data.length) {
        return state.dictionary.data.data[0];
      } else {
        return null;
      }
    },
    translate: function translate(state) {
      return function (sheet, item) {
        if (!item) return '';
        if (state.dictionary.data && state.dictionary.data.data && state.dictionary.data.data.length) {
          var dict = state.dictionary.data.data[0];
          var lang = state.selectedLanguage;
          switch (sheet) {
            case 'interfata':
              {
                return dict[sheet][item] ? dict.interfata[item][lang] : item;
              }
            case 'texte':
            case 'popups':
            case 'date':
              {
                if (lang === 'RO') return item;
                var s = __WEBPACK_IMPORTED_MODULE_0_slug___default()(item);
                return dict[sheet][s] ? dict[sheet][s][lang] : item;
              }
          }
        }
        return item;
      };
    },

    languages: function languages(state) {
      if (state.dictionary.data.data && state.dictionary.data.data.length) {
        return state.dictionary.data.data[0].langs;
      }
      return null;
    },
    selectedLanguage: function selectedLanguage(state) {
      return state.selectedLanguage;
    },
    languageSet: function languageSet(state) {
      return state.languageSet;
    }
  },
  mutations: {
    setLanguage: function setLanguage(state, langOptions) {
      state.selectedLanguage = langOptions.lang;
      state.languageSet = langOptions.languageSet;
      if (langOptions.languageSet) {
        __WEBPACK_IMPORTED_MODULE_1_cookies_js___default.a.set('bgt-lang', langOptions.lang);
      }
    },
    fillDictionarys: function fillDictionarys(state, data) {
      state.dictionary.data = data;
    },
    clearDictionarys: function clearDictionarys(state) {
      state.dictionary.data = [];
    },
    setDictionarysPage: function setDictionarysPage(state, page) {
      state.dictionary.page = page;
    },
    setDictionarysSort: function setDictionarysSort(state, sort) {
      state.dictionary.sort = sort;
    },
    setDictionarysSearch: function setDictionarysSearch(state, search) {
      state.dictionary.search = search;
    }
  },
  actions: {
    fetchDictionarys: function fetchDictionarys(_ref) {
      var commit = _ref.commit,
          state = _ref.state,
          rootState = _ref.rootState;

      commit('setFetching', true);
      var query = {
        $skip: (state.dictionary.page - 1) * 10,
        $sort: state.dictionary.sort
      };
      if (state.dictionary.search.length) {
        query['orRegex'] = [{
          name: {
            $search: state.dictionary.search
          }
        }];
      }
      rootState.services.dictionary.find({ query: query }).then(function (result) {
        commit('fillDictionarys', result);
        commit('setFetching', false);
      });
    },
    saveDictionary: function saveDictionary(_ref2, data) {
      var dispatch = _ref2.dispatch,
          commit = _ref2.commit,
          state = _ref2.state,
          rootState = _ref2.rootState;

      rootState.services.dictionar.create(data).then(function (res) {
        dispatch('fetchDictionarys');
        commit('setSnack', {
          message: 'Operatiune reusita. Dictionary adaugat.',
          meta: {
            error: false,
            success: true,
            info: false,
            warning: false
          }
        });
      }).catch(function (error) {
        error.meta = { error: true, success: false, info: false, warning: false };
        commit('setSnack', error);
      });
    },
    updateDictionary: function updateDictionary(_ref3, data) {
      var dispatch = _ref3.dispatch,
          commit = _ref3.commit,
          state = _ref3.state,
          rootState = _ref3.rootState;

      rootState.services.dictionary.update(data._id, data).then(function (res) {
        dispatch('fetchDictionarys');
        commit('setSnack', {
          message: 'Operatiune reusita. Dictionary modificat.',
          meta: {
            error: false,
            success: true,
            info: false,
            warning: false
          }
        });
      }).catch(function (error) {
        error.meta = { error: true, success: false, info: false, warning: false };
        commit('setSnack', error);
      });
    },
    deleteDictionary: function deleteDictionary(_ref4, _ids) {
      var dispatch = _ref4.dispatch,
          commit = _ref4.commit,
          state = _ref4.state,
          rootState = _ref4.rootState;

      rootState.services.dictionary.remove(null, { query: { _id: { $in: _ids } } }).then(function (res) {
        dispatch('fetchDictionarys');
        commit('setSnack', {
          message: 'Operatiune reusita. ' + res.length + ' dictionary(e) eliminat(e).',
          meta: {
            error: false,
            success: true,
            info: false,
            warning: false
          }
        });
      }).catch(function (error) {
        error.meta = { error: true, success: false, info: false, warning: false };
        commit('setSnack', error);
      });
    },
    setDictionarysPage: function setDictionarysPage(_ref5, page) {
      var commit = _ref5.commit,
          dispatch = _ref5.dispatch;

      commit('setDictionarysPage', page);
      dispatch('fetchDictionarys');
    },
    setDictionarysSort: function setDictionarysSort(_ref6, sort) {
      var commit = _ref6.commit,
          dispatch = _ref6.dispatch;

      commit('setDictionarysSort', sort);
      dispatch('fetchDictionarys');
    },
    setDictionarySearch: function setDictionarySearch(_ref7, search) {
      var commit = _ref7.commit,
          dispatch = _ref7.dispatch;

      commit('setDictionarySearch', search);
      dispatch('fetchDictionarys');
    }
  }
});

/***/ }),

/***/ 95:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    downloads: {
      data: [],
      search: '',
      page: 1,
      totalPages: 1,
      sort: {
        name: 1
      }
    }
  },
  getters: {
    getAllDownloads: function getAllDownloads(state) {
      return state.downloads;
    },
    getDownloadsPage: function getDownloadsPage(state) {
      return state.downloads.page;
    },
    getDownloadSearch: function getDownloadSearch(state) {
      return state.downloads.search;
    },
    getDownloadsData: function getDownloadsData(state) {
      if (state.downloads.data && state.downloads.data.data && state.downloads.data.data.length) {
        return state.downloads.data.data[0];
      } else {
        return null;
      }
    }
  },
  mutations: {
    fillDownloads: function fillDownloads(state, data) {
      state.downloads.data = data;
    },
    clearDownloads: function clearDownloads(state) {
      state.downloads.data = [];
    },
    setDownloadsPage: function setDownloadsPage(state, page) {
      state.downloads.page = page;
    },
    setDownloadsSort: function setDownloadsSort(state, sort) {
      state.downloads.sort = sort;
    },
    setDownloadsSearch: function setDownloadsSearch(state, search) {
      state.downloads.search = search;
    }
  },
  actions: {
    fetchDownloads: function fetchDownloads(_ref) {
      var commit = _ref.commit,
          state = _ref.state,
          rootState = _ref.rootState;

      commit('setFetching', true);
      var query = {
        $skip: (state.downloads.page - 1) * 10,
        $sort: state.downloads.sort
      };
      if (state.downloads.search.length) {
        query['orRegex'] = [{
          name: {
            $search: state.downloads.search
          }
        }];
      }
      rootState.services.downloads.find({ query: query }).then(function (result) {
        commit('fillDownloads', result);
        commit('setFetching', false);
      });
    },
    saveDownload: function saveDownload(_ref2, data) {
      var dispatch = _ref2.dispatch,
          commit = _ref2.commit,
          state = _ref2.state,
          rootState = _ref2.rootState;

      rootState.services.downloads.create(data).then(function (res) {
        dispatch('fetchDownloads');
        commit('setSnack', {
          message: 'Operatiune reusita. Pagina adaugata.',
          meta: {
            error: false,
            success: true,
            info: false,
            warning: false
          }
        });
      }).catch(function (error) {
        error.meta = { error: true, success: false, info: false, warning: false };
        commit('setSnack', error);
      });
    },
    updateDownload: function updateDownload(_ref3, data) {
      var dispatch = _ref3.dispatch,
          commit = _ref3.commit,
          state = _ref3.state,
          rootState = _ref3.rootState;

      rootState.services.downloads.update(data._id, data).then(function (res) {
        dispatch('fetchDownloads');
        commit('setSnack', {
          message: 'Operatiune reusita. Pagina modificata.',
          meta: {
            error: false,
            success: true,
            info: false,
            warning: false
          }
        });
      }).catch(function (error) {
        error.meta = { error: true, success: false, info: false, warning: false };
        commit('setSnack', error);
      });
    },
    deleteDownload: function deleteDownload(_ref4, _ids) {
      var dispatch = _ref4.dispatch,
          commit = _ref4.commit,
          state = _ref4.state,
          rootState = _ref4.rootState;

      rootState.services.downloads.remove(null, { query: { _id: { $in: _ids } } }).then(function (res) {
        dispatch('fetchDownloads');
        commit('setSnack', {
          message: 'Operatiune reusita. ' + res.length + ' pagina(i) eliminata(e).',
          meta: {
            error: false,
            success: true,
            info: false,
            warning: false
          }
        });
      }).catch(function (error) {
        error.meta = { error: true, success: false, info: false, warning: false };
        commit('setSnack', error);
      });
    },
    setDownloadsPage: function setDownloadsPage(_ref5, page) {
      var commit = _ref5.commit,
          dispatch = _ref5.dispatch;

      commit('setDownloadsPage', page);
      dispatch('fetchDownloads');
    },
    setDownloadsSort: function setDownloadsSort(_ref6, sort) {
      var commit = _ref6.commit,
          dispatch = _ref6.dispatch;

      commit('setDownloadsSort', sort);
      dispatch('fetchDownloads');
    },
    setDownloadSearch: function setDownloadSearch(_ref7, search) {
      var commit = _ref7.commit,
          dispatch = _ref7.dispatch;

      commit('setDownloadSearch', search);
      dispatch('fetchDownloads');
    }
  }
});

/***/ }),

/***/ 96:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    flyers: {
      data: [],
      search: '',
      page: 1,
      totalPages: 1,
      sort: {
        name: 1
      }
    }
  },
  getters: {
    getAllFlyers: function getAllFlyers(state) {
      return state.flyers;
    },
    getFlyersPage: function getFlyersPage(state) {
      return state.flyers.page;
    },
    getFlyerSearch: function getFlyerSearch(state) {
      return state.flyers.search;
    },
    getFlyersData: function getFlyersData(state) {
      if (state.flyers.data && state.flyers.data.data && state.flyers.data.data.length) {
        return state.flyers.data.data;
      } else {
        return null;
      }
    }
  },
  mutations: {
    fillFlyers: function fillFlyers(state, data) {
      state.flyers.data = data;
    },
    clearFlyers: function clearFlyers(state) {
      state.flyers.data = [];
    },
    setFlyersPage: function setFlyersPage(state, page) {
      state.flyers.page = page;
    },
    setFlyersSort: function setFlyersSort(state, sort) {
      state.flyers.sort = sort;
    },
    setFlyersSearch: function setFlyersSearch(state, search) {
      state.flyers.search = search;
    }
  },
  actions: {
    fetchFlyers: function fetchFlyers(_ref) {
      var commit = _ref.commit,
          state = _ref.state,
          rootState = _ref.rootState;

      commit('setFetching', true);
      var query = {
        $skip: (state.flyers.page - 1) * 10,
        $sort: state.flyers.sort
      };
      if (state.flyers.search.length) {
        query['orRegex'] = [{
          name: {
            $search: state.flyers.search
          }
        }];
      }
      rootState.services.flyers.find({ query: query }).then(function (result) {
        commit('fillFlyers', result);
        commit('setFetching', false);
      });
    },
    saveFlyer: function saveFlyer(_ref2, data) {
      var dispatch = _ref2.dispatch,
          commit = _ref2.commit,
          state = _ref2.state,
          rootState = _ref2.rootState;

      rootState.services.flyers.create(data).then(function (res) {
        dispatch('fetchFlyers');
        commit('setSnack', {
          message: 'Operatiune reusita. Flyer adaugat.',
          meta: {
            error: false,
            success: true,
            info: false,
            warning: false
          }
        });
      }).catch(function (error) {
        error.meta = { error: true, success: false, info: false, warning: false };
        commit('setSnack', error);
      });
    },
    updateFlyer: function updateFlyer(_ref3, data) {
      var dispatch = _ref3.dispatch,
          commit = _ref3.commit,
          state = _ref3.state,
          rootState = _ref3.rootState;

      rootState.services.flyers.update(data._id, data).then(function (res) {
        dispatch('fetchFlyers');
        commit('setSnack', {
          message: 'Operatiune reusita. Flyer modificat.',
          meta: {
            error: false,
            success: true,
            info: false,
            warning: false
          }
        });
      }).catch(function (error) {
        error.meta = { error: true, success: false, info: false, warning: false };
        commit('setSnack', error);
      });
    },
    deleteFlyer: function deleteFlyer(_ref4, _ids) {
      var dispatch = _ref4.dispatch,
          commit = _ref4.commit,
          state = _ref4.state,
          rootState = _ref4.rootState;

      rootState.services.flyers.remove(null, { query: { _id: { $in: _ids } } }).then(function (res) {
        dispatch('fetchFlyers');
        commit('setSnack', {
          message: 'Operatiune reusita. ' + res.length + ' flyer(e) eliminat(e).',
          meta: {
            error: false,
            success: true,
            info: false,
            warning: false
          }
        });
      }).catch(function (error) {
        error.meta = { error: true, success: false, info: false, warning: false };
        commit('setSnack', error);
      });
    },
    setFlyersPage: function setFlyersPage(_ref5, page) {
      var commit = _ref5.commit,
          dispatch = _ref5.dispatch;

      commit('setFlyersPage', page);
      dispatch('fetchFlyers');
    },
    setFlyersSort: function setFlyersSort(_ref6, sort) {
      var commit = _ref6.commit,
          dispatch = _ref6.dispatch;

      commit('setFlyersSort', sort);
      dispatch('fetchFlyers');
    },
    setFlyerSearch: function setFlyerSearch(_ref7, search) {
      var commit = _ref7.commit,
          dispatch = _ref7.dispatch;

      commit('setFlyerSearch', search);
      dispatch('fetchFlyers');
    }
  }
});

/***/ }),

/***/ 97:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    settings: {
      data: [],
      search: '',
      page: 1,
      totalPages: 1,
      sort: {
        name: 1
      }
    }
  },
  getters: {
    getAllSettings: function getAllSettings(state) {
      return state.settings;
    },
    getSettingsPage: function getSettingsPage(state) {
      return state.settings.page;
    },
    getSettingSearch: function getSettingSearch(state) {
      return state.settings.search;
    }
  },
  mutations: {
    fillSettings: function fillSettings(state, data) {
      state.settings.data = data;
    },
    clearSettings: function clearSettings(state) {
      state.settings.data = [];
    },
    setSettingPage: function setSettingPage(state, page) {
      state.settings.page = page;
    },
    setSettingsSort: function setSettingsSort(state, sort) {
      state.settings.sort = sort;
    },
    setSettingSearch: function setSettingSearch(state, search) {
      state.settings.search = search;
    }
  },
  actions: {
    fetchSettings: function fetchSettings(_ref) {
      var commit = _ref.commit,
          state = _ref.state,
          rootState = _ref.rootState;

      commit('setFetching', true);
      var query = {
        $skip: (state.settings.page - 1) * 10,
        $sort: state.settings.sort
      };
      if (state.settings.search.length) {
        query['orRegex'] = [{
          name: {
            $search: state.settings.search
          }
        }];
      }
      rootState.services.settings.find({ query: query }).then(function (result) {
        commit('fillSettings', result);
        commit('setFetching', false);
      });
    },
    saveSetting: function saveSetting(_ref2, data) {
      var dispatch = _ref2.dispatch,
          commit = _ref2.commit,
          state = _ref2.state,
          rootState = _ref2.rootState;

      rootState.services.settings.create(data).then(function (res) {
        dispatch('fetchSettings');
        commit('setSnack', {
          message: 'Operatiune reusita. Setare adaugata.',
          meta: {
            error: false,
            success: true,
            info: false,
            warning: false
          }
        });
      }).catch(function (error) {
        error.meta = { error: true, success: false, info: false, warning: false };
        commit('setSnack', error);
      });
    },
    updateSetting: function updateSetting(_ref3, data) {
      var dispatch = _ref3.dispatch,
          commit = _ref3.commit,
          state = _ref3.state,
          rootState = _ref3.rootState;

      rootState.services.settings.patch(data._id, data).then(function (res) {
        dispatch('fetchSettings');
        commit('setSnack', {
          message: 'Operatiune reusita. Setare modificata.',
          meta: {
            error: false,
            success: true,
            info: false,
            warning: false
          }
        });
      }).catch(function (error) {
        error.meta = { error: true, success: false, info: false, warning: false };
        commit('setSnack', error);
      });
    },
    deleteSetting: function deleteSetting(_ref4, _ids) {
      var dispatch = _ref4.dispatch,
          commit = _ref4.commit,
          state = _ref4.state,
          rootState = _ref4.rootState;

      rootState.services.settings.remove(null, { query: { _id: { $in: _ids } } }).then(function (res) {
        dispatch('fetchSettings');
        commit('setSnack', {
          message: 'Operatiune reusita. ' + res.length + ' setare(i) eliminata(e).',
          meta: {
            error: false,
            success: true,
            info: false,
            warning: false
          }
        });
      }).catch(function (error) {
        error.meta = { error: true, success: false, info: false, warning: false };
        commit('setSnack', error);
      });
    },
    setSettingPage: function setSettingPage(_ref5, page) {
      var commit = _ref5.commit,
          dispatch = _ref5.dispatch;

      commit('setSettingPage', page);
      dispatch('fetchSettings');
    },
    setSettingsSort: function setSettingsSort(_ref6, sort) {
      var commit = _ref6.commit,
          dispatch = _ref6.dispatch;

      commit('setSettingsSort', sort);
      dispatch('fetchSettings');
    },
    setSettingSearch: function setSettingSearch(_ref7, search) {
      var commit = _ref7.commit,
          dispatch = _ref7.dispatch;

      commit('setSettingSearch', search);
      dispatch('fetchSettings');
    }
  }
});

/***/ }),

/***/ 98:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    users: {
      data: [],
      search: '',
      page: 1,
      totalPages: 1,
      sort: {
        username: 1
      }
    }
  },
  getters: {
    getAllUsers: function getAllUsers(state) {
      return state.users;
    },
    getUsersPage: function getUsersPage(state) {
      return state.users.page;
    },
    getUserSearch: function getUserSearch(state) {
      return state.users.search;
    }
  },
  mutations: {
    fillUsers: function fillUsers(state, data) {
      state.users.data = data;
      state.users;
    },
    clearUsers: function clearUsers(state) {
      state.users.data = [];
    },
    setUsersPage: function setUsersPage(state, page) {
      state.users.page = page;
    },
    setUsersSort: function setUsersSort(state, sort) {
      state.users.sort = sort;
    },
    setUserSearch: function setUserSearch(state, search) {
      state.users.search = search;
    }
  },
  actions: {
    fetchUsers: function fetchUsers(_ref) {
      var commit = _ref.commit,
          rootState = _ref.rootState,
          state = _ref.state;

      commit('setFetching', true);
      var query = {
        $skip: (state.users.page - 1) * 10,
        $sort: state.users.sort
      };
      if (state.users.search.length) {
        query['orRegex'] = [{
          username: {
            $search: state.users.search
          }
        }, {
          email: {
            $search: state.users.search
          }
        }];
      }
      rootState.services.users.find({ query: query }).then(function (result) {
        commit('fillUsers', result);
        commit('setFetching', false);
      });
    },
    saveUser: function saveUser(_ref2, data) {
      var dispatch = _ref2.dispatch,
          commit = _ref2.commit,
          state = _ref2.state,
          rootState = _ref2.rootState;

      rootState.services.users.create(data).then(function (res) {
        dispatch('fetchUsers');
        commit('setSnack', {
          message: 'Operatiune reusita. Utilizator adaugat.',
          meta: {
            error: false,
            success: true,
            info: false,
            warning: false
          }
        });
      }).catch(function (error) {
        error.meta = { error: true, success: false, info: false, warning: false };
        commit('setSnack', error);
      });
    },
    updateUser: function updateUser(_ref3, data) {
      var dispatch = _ref3.dispatch,
          commit = _ref3.commit,
          state = _ref3.state,
          rootState = _ref3.rootState;

      rootState.services.users.patch(data._id, data).then(function (res) {
        dispatch('fetchUsers');
        commit('setSnack', {
          message: 'Operatiune reusita. Utilizator modificat.',
          meta: {
            error: false,
            success: true,
            info: false,
            warning: false
          }
        });
      }).catch(function (error) {
        error.meta = { error: true, success: false, info: false, warning: false };
        commit('setSnack', error);
      });
    },
    toggleSuperadmin: function toggleSuperadmin(_ref4, data) {
      var dispatch = _ref4.dispatch,
          commit = _ref4.commit,
          state = _ref4.state,
          rootState = _ref4.rootState;

      rootState.services.users.patch(data._id, { superadmin: data.superadmin }).then(function (res) {
        dispatch('fetchUsers');
        commit('setSnack', {
          message: 'Operatiune reusita. Utilizatorul ' + res.username + ' a fost ' + (res.superadmin ? 'promovat' : 'retrogradat') + '.',
          meta: {
            error: false,
            success: true,
            info: false,
            warning: false
          }
        });
      }).catch(function (error) {
        error.meta = { error: true, success: false, info: false, warning: false };
        commit('setSnack', error);
      });
    },
    deleteUser: function deleteUser(_ref5, _ids) {
      var dispatch = _ref5.dispatch,
          commit = _ref5.commit,
          state = _ref5.state,
          rootState = _ref5.rootState;

      rootState.services.users.remove(null, { query: { _id: { $in: _ids } } }).then(function (res) {
        dispatch('fetchUsers');
        commit('setSnack', {
          message: 'Operatiune reusita. ' + res.length + ' utilizator(i) eliminat(i).',
          meta: {
            error: false,
            success: true,
            info: false,
            warning: false
          }
        });
      }).catch(function (error) {
        error.meta = { error: true, success: false, info: false, warning: false };
        commit('setSnack', error);
      });
    },
    setEventWatchers: function setEventWatchers(_ref6) {
      var dispatch = _ref6.dispatch,
          commit = _ref6.commit,
          rootState = _ref6.rootState;

      rootState.services.users.on('created', function (user) {
        dispatch('fetchUsers');
      });
      rootState.services.users.on('updated', function (user) {
        dispatch('fetchUsers');
      });
      rootState.services.users.on('patched', function (user) {
        dispatch('fetchUsers');
      });
      rootState.services.users.on('removed', function (user) {
        dispatch('fetchUsers');
      });
    },
    checkEmail: function checkEmail(_ref7, email) {
      var rootState = _ref7.rootState;

      return rootState.services.users.find({ query: { email: email } });
    },
    setUsersPage: function setUsersPage(_ref8, page) {
      var commit = _ref8.commit,
          dispatch = _ref8.dispatch;

      commit('setUsersPage', page);
      dispatch('fetchUsers');
    },
    setUsersSort: function setUsersSort(_ref9, sort) {
      var commit = _ref9.commit,
          dispatch = _ref9.dispatch;

      commit('setUsersSort', sort);
      dispatch('fetchUsers');
    },
    setUserSearch: function setUserSearch(_ref10, search) {
      var commit = _ref10.commit,
          dispatch = _ref10.dispatch;

      commit('setUserSearch', search);
      dispatch('fetchUsers');
    }
  }
});

/***/ }),

/***/ 99:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Layout_vue__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Layout_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Layout_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'tud-layout': __WEBPACK_IMPORTED_MODULE_0__components_Layout_vue___default.a
  },
  computed: {
    light: function light() {
      return this.$store.getters.appLight;
    }
  },
  created: function created() {
    this.$store.dispatch('attemptAuth');
  }
});

/***/ })

},[91]);


// WEBPACK FOOTER //
// static/js/app.f44d738c2cf2199ea2e5.js